import { render, staticRenderFns } from "./no-result.vue?vue&type=template&id=789a99c9&scoped=true&"
import script from "./no-result.vue?vue&type=script&lang=js&"
export * from "./no-result.vue?vue&type=script&lang=js&"
import style0 from "./no-result.vue?vue&type=style&index=0&id=789a99c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789a99c9",
  null
  
)

export default component.exports